// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"188": "3f548b57f9161145","830": "76b0767f0274805a",}[chunkId] + ".js"
}